const videoModule = {
  id: "abd065b2-a14e-3292-8541-2f25fdbfd691",
  component: "CRVideo",
  config: {
    general: {
      blockWidth: {
        label: "Third",
        value: "third",
      },
      template: {
        label: "Big",
        component: "VideoBig",
      },
      paddings: {
        top: true,
        bottom: true,
      },
      backgroundColor: {
        label: "Cornsilk",
        value: "#fff8dc",
      },
      playButtonColor: {
        label: "Cornsilk",
        value: "#fff8dc",
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      thumbnail: {
        media: {
          url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
          mediaType: "image",
        },
      },
      corners: {
        label: "Round",
        value: "round",
      },
      video: {
        source: {
          label: "Upload",
          value: "upload",
        },
        uploadedVideo: {
          media: {
            url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
            mediaType: "video",
          },
        },
        // YouTube
        embeddedVideoUrl: "https://www.youtube.com/watch?v=04mZxyTnjaQ",

        // Vimeo
        //embeddedVideoUrl: "https://player.vimeo.com/video/875784142?h=3ed6db7c17&autoplay=1"

        // Watchado
        //embeddedVideoUrl: "https://www.whatchado.com/de/embeds/videos/vertriebbeiwhatchado"

        // Other source
        //embeddedVideoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      },
    },
  },
};

export default videoModule;
